<template>
  <div class="container">
    <div class="wait-screen-animation">
      <div class="wait-screen-animation__animation-card">
        <div class="wait-screen-animation__animation">
          <LottiePlayer
            :animation-data="animationData"
          />
        </div>
        <span class="wait-screen-animation__animation-text">This process may take 3-5 minutes</span>
      </div>
    </div>
  </div>
</template>

<script>
import LottiePlayer from '@/components/common/lottie/LottiePlayer.vue'

export default {
  name: 'WaitScreenAnimationAwards',

  components: {
    LottiePlayer
  },

  data () {
    return {
      animationData: require('@/assets/lottie/delay/delay-animation.json')
    }
  }
}

</script>

<style lang="scss" scoped>
.wait-screen-animation {
  @apply mx-auto flex flex-col items-center;

  &__animation {
    @apply mb-auto pt-20;

    &-card {
      @apply w-320 h-370 bg-white shadow-card py-25 px-35 rounded-15;
      @apply mb-50 flex flex-col items-center;
    }

    &-text {
      @apply text-md text-center;
    }
  }

  &__awards {
    @apply flex flex-row justify-between mx-auto w-full;
  }
}
</style>
